import React from "react";
import { useEffect, useRef, useState } from "react";

import WaveSurfer from "wavesurfer.js";
import RecordPlugin from "wavesurfer.js/dist/plugins/record.esm.js";

const VoiceCapture = (props) => {
  const formatTime = (seconds) =>
    [seconds / 60, seconds % 60]
      .map((v) => `0${Math.floor(v)}`.slice(-2))
      .join(":");

  const [currentTime, setCurrentTime] = useState(formatTime(0));
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioRecorded, setAudioRecorded] = useState(false);
  const [isRecording, setIsRecording] = useState(false);

  let record = useRef(null);
  let wavesurfer = useRef(null);
  let deviceId = useRef(null);
  
  const updateProgress = (time) => {
    // time will be in milliseconds, convert it to mm:ss format
    const formattedTime = [
      Math.floor((time % 3600000) / 60000), // minutes
      Math.floor((time % 60000) / 1000), // seconds
    ]
      .map((v) => (v < 10 ? "0" + v : v))
      .join(":");
    
    setCurrentTime(formattedTime);
  };

  useEffect(() => {
    wavesurfer.current = WaveSurfer.create({
      container: "#mic",
      waveColor: "rgb(200, 0, 200)",
      progressColor: "rgb(100, 0, 100)",
    });

    // Initialize the Record plugin
    record.current = wavesurfer.current.registerPlugin(
      RecordPlugin.create({ renderRecordedAudio: false })
    );

    // Render recorded audio
    record.current.on("record-end", (blob) => {
      const container = document.querySelector("#mic");
      container.innerHTML = "";
      const recordedUrl = URL.createObjectURL(blob);
      props.setAudioRecordedFile(blob);
      // Create wavesurfer from the recorded audio
      wavesurfer.current = WaveSurfer.create({
        container,
        waveColor: "rgb(200, 100, 0)",
        progressColor: "rgb(100, 50, 0)",
        url: recordedUrl,
      });
    });

    record.current.on("record-progress", (time) => {
      updateProgress(time);
    });

    {
      // Mic selection
      RecordPlugin.getAvailableAudioDevices().then((devices) => {
        deviceId.current = devices[0].deviceId;
      });
    }
  }, []);

  const handleRecord = () => {
    setIsRecording(true);

    // get selected device
    record.current.startRecording({ deviceId: deviceId.current }).then(() => {});
  };

  const handleStop = () => {
    setAudioRecorded(true);
    if (record.current.isRecording() || record.current.isPaused()) {
      record.current.stopRecording();
    }
  };

  const handlePlay = () => {
    wavesurfer.current.playPause();
    setIsPlaying(true);
  };

  const handlePause = () => {
    wavesurfer.current.playPause();
    setIsPlaying(false);
  };

  return (
    <>

      <p>Current time: {currentTime}</p>

      <div style={{ margin: "1em 0", display: "flex", gap: "1em" }}>
        {!audioRecorded && !isRecording && (
          <button style={{ minWidth: "5em" }} onClick={handleRecord}>
            Record
          </button>
        )}
        {!audioRecorded && isRecording && (
          <button style={{ minWidth: "5em" }} onClick={handleStop}>
            Stop
          </button>
        )}

        {audioRecorded && (
          <>
            {!isPlaying && (
              <button onClick={handlePlay} style={{ minWidth: "5em" }}>
                Play
              </button>
            )}
            {isPlaying && (
              <button onClick={handlePause} style={{ minWidth: "5em" }}>
                Pause
              </button>
            )}
          </>
        )}
      </div>
      <div
        id="mic"
        style={{
          border: "1px solid #ddd",
          borderRadius: "4px",
          marginTop: "1rem",
        }}
      ></div>
    </>
  );
};

export default VoiceCapture;
